import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfCatalogUiModule } from '@df/catalog-ui/df-catalog-ui.module';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { CmsBlogPostComponent } from '../../../../../cms/blog/post/cms-blog-post.component';
import { NBloomreach } from '../../../../../module/bloomreach/bloomreach.namespace';
import { CustomCursorComponent } from '../../../../../ui/display/custom-cursor/custom-cursor.component';
import { CategoryComponent } from '../../../category/category.component';
import { ProductComponent } from '../../../product/product.component';
import { addBloomreachRecommendationsVariant } from '../bloomreach-recommendations/bloomreach-recommendations.config';
import { LocalModelCarouselComponent } from '../local-model-carousel/local-model-carousel.component';
import { getFields } from '../local-model-carousel/local-model-carousel.config';
import { ILocalModelCarouselData } from '../local-model-carousel/local-model-carousel.interface';
import { IModelCarouselDataItem } from '../model-carousel/model-carousel.interface';

interface ILocalProductCarouselData extends ILocalModelCarouselData, NBloomreach.IRecommendationsOptions<IModelCarouselDataItem[]> {}

@Component({
    selector: 'page-component-product-carousel',
    templateUrl: './../local-model-carousel/local-model-carousel.html',
    styleUrl: './../local-model-carousel/local-model-carousel.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CategoryComponent,
        CmsBlogPostComponent,
        CommonModule,
        CustomCursorComponent,
        DfCatalogUiModule,
        DfImageDirective,
        DfImageWrapperComponent,
        GtmTrackViewItemListDirective,
        CarouselComponent,
        CarouselSlideDirective,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        forwardRef(() => ProductComponent),
        RouterModule,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentProductCarouselComponent>({
    id: 'product-carousel-v1',
    name: 'Product Carousel (Variant 1)',
    image: 'assets/images/cms/product-carousel.png',
    description: 'Standard carousel',
    tags: ['Homepage, Landing, Blog, Inspiration, About us'],
    fields: addBloomreachRecommendationsVariant(getFields(Product.type))
})
export class PageComponentProductCarouselComponent extends LocalModelCarouselComponent<Product<IProductDataV2>, ILocalProductCarouselData> {
    type = Product.type;
}
